import LanguageMessages from "./LanguageMessages";

const russianMessages: LanguageMessages = {
    NavBar: {
        HomeTitle: 'Новости',
        AccordionsTitle: 'Аккордеоны',
        ContactTitle: 'Контакт',
        CompanyTitle: 'компания',
        TeamTitle: 'Команда',
        LogoutTitle: 'Выйти',
        AccessoriesTitle: 'аксессуары',
    },
    RollingCredits: {
        DialogTitle: 'Управление текстом',
    },
    Footer: {
        firm: "",
        addressLineOne: "АВНЫЙ ПРЕДСТАВИТЕЛЬ В РОССИИ",
        addressLineTwo: "ПИГИНИ И ЭКСЕЛЬСИОР",
        addressLineThree: "Зайцев Павел",
        address: "БРЮСОВ ПЕРЕУЛОК, 1/2",
        plz: '115563',
        city: 'МОСКВА',
        telephone: '',
        mobile: 'Мобильный: (Wapp/Telegram/Viber) +7(903)583-23-71',
        emailLabel: 'Эл. адресl:',
        email: 'info@pigini-excelsior.ru'
    },
    HomePage: {
        HomeShopShortcut: {
            titleText: 'Изучите нашу отличную коллекцию аккордеонов, в которую входят специально отобранные модели от Pigini и Excelsior Accordions. Ощутите очарование и мастерство этих красиво спроектированных инструментов. Погрузитесь в мир этих мастерски созданных, артистических инструментов.'
        }
    },
    TeamPage: {
        title: 'Команда',
        teamMembers: [
            {
                name: 'Мартин Фрей',
                text: [
                    '',
                    '[[[bold]]]Обучение',
                    'Университетский факультет гражданского строительства (Бругг-Виндиш / Швейцария)',
                    '- Дипломированный инженер-строитель HTL (позже FH)',
                    'Аспирантура: ',
                    '- MAS-ND-U (Корпоративное управление/Люцернский университет прикладных наук в \tХорве/Швейцария)',
                    '- MAS-CIM (Компьютерно-интегрированное производство / Brugg-Windisch / Швейцария)',
                    '',
                    '[[[bold]]]Менеджер проектов и инжиниринг',
                    'Многолетний опыт работы в отечественном гражданском и строительном строительстве, международный опыт в машиностроении (включая производство аккордеонов), в автомобильной промышленности, аэрокосмических технологиях и робототехнике.',
                    'Многолетний опыт работы в национальных и международных проектах по консалтингу и моделированию процессов (Aeneis, Six-Sigma, Wassermann {моделирование процессов} SAP-R3), системах SOX и IKS.',
                    'Национальные и международные технологические проекты в крупных энергетических компаниях.',
                    '',
                    '[[[bold]]]Международный музыкальный опыт',
                    'Организатор концертов и семинаров различных направлений и жанров, в том числе аккордеонных концертов. (Фридрих Липс, Вячеслав Семёнов, Юрий Шишкин, Фрэнк Марокко, Московская группа тембровых русских аккордеонов, Оркестр Павла Смирнова, Новозеландский аккордеонный оркестр, Фрэнк Марокко, Фан Юань и другие)',
                    '',
                    '[[[bold]]]Генеральное агентство по аккордеонам',
                    'для ведущего мирового производителя аккордеонов высокого класса брендов PIGINI & EXCELSIOR',
                    '- 35 лет Швейцарии и Лихтенштейна (владелец генерального агентства)',
                    '- около 10 лет в России (операционное управление генеральным агентством)'
                ]
            },
            {
                name: 'Павел Зайцев',
                text: [
                    '(Исполнитель, преподаватель)',
                    '',
                    '- Окончил РАМ им. Гнесиных(проф. Ф.Р. Липс).',
                    '- Лауреат Международных конкурсов.',
                    '- Солист ансамбля РУССКИЙ ТЕМБР.',
                    '- Лауреат премии губернатора Московской области',
                    '- в области культуры и искусства.',
                    '- Выступает с концертами в России и зарубежом.',
                    '- Заслуженный артист России.'
                ]
        },
            {
                name: 'Юрий Жмодик',
                text: [
                    '(Исполнитель, преподаватель).',
                    '',
                    '- Окончил МГК им.Шнитке ( класс И.Г.Пурица), Окончил РАМ им.Гнессиных (профессор В.Беляков).',
                    '- Лауреат международных конкурсов в Италии (Ланчиано,Кастельфидардо).',
                    '- Лауреат в качестве преподавателя 14 -Го международного конкурса',
                    '- баянистов, аккордеонистов (2017 год, Литва, Каунасская государственная консерватория).'
                ]
            }]
    },
    CompanyPage: {
        AboutUs: {
            title: 'О нас',
            pAndSSwitzerland: {
                subtitle: 'PIGINI & EXCELSIOR в Швейцарии и России',
                text: 'Фирма PIGINI занимает самые высокие рейтинги в производстве Баянов и Аккордеонов.  Это исторические традиции и новейшие разработки современного качества. Фирма PIGINI опирается на многолетний опыт талантливых мастеров Италии и всего мира. На этих инструментах играют такие музыканты как Ф.Липс, В.Семёнов, А.Дмитриев, С.Осокин, А.Малхасьян, К.Русинов.',
            },
            relationships: {
                subtitle: 'Что нас oбъединяет',
                text: 'Для производства своих прекрасных инструментов фирма PIGINI уделяет большое значение тесным контактам с Солистами, Оркестрами, Консерваториями, музыкальными Школами и Учителями мирового уровня. Такие отношения через наше представительство PIGINI во всём Мире являются фактором успеха инструментов высочайшего уровня.',
            },
            since: {
                subtitle: 'Представительству PIGINI & EXCЕLSIOR в Швейцарии 1990',
                text: 'Основанное в 1990 году Коммерческое Представительство PIGINI & EXCELSIOR в Швейцарии и России возложило на себя ответственность в Продвижении и Поддержке инструментов PIGINI и EXCELSIOR, а также организации достойного Сервиса. Мы горды тем, что мы можем предложить Вам Баяны и Аккордеоны, опережающие ваши желания по Красоте и Качеству звука.',
            },
            ourService: {
                subtitle: 'Наш Сервис',
                text: 'Добро пожаловать и мы всегда рады обращениям к нам. Вы хотите купить Инструмент, исходя из Ваших индивидуальных пожеланий? Мы предоставим Вам серьёзную и основательную консультацию и помощь.'
            },
            comeSee: {
                subtitle: 'Знакомство и пробная игра',
                text: 'Вы хотите подобрать по звуку и размерам подходящий инструмент? Свяжитесь с нашими представителями в Москве и Вы будете всегда встречены  с понимаем и любовью к Баяну/Аккордеону и, конечно, Музыке. Мы рады вас приветствовать у нас и Добро пожаловать в наш Мир!',
            },
        },
        AboutPigini: {
            title: 'О PIGINI',
            tradition: {
                subtitle: 'Традиции',
                text: '6 Июня 1946 года Филиппо Пиджини в Мануфактурном реестре города Анкона (Италия) зарегистрировал фирму „Flli. PIGINI di Filippo”. К её созданию он привлёк своих сыновей - Адриано, Джино, Луиджи и Марино. \n' +
                    'Филиппо Пиджини - человек с незаурядными организаторскими способностями. Он позаботился о том, чтобы его сыновья, вернувшись домой с войны в 1930 году, взялись за работу в семейной мастерской. Вскоре был создан первый Аккордеон.'
            },
            foundingYears: {
                subtitle: 'Годы создания',
                text: 'Послевоенные годы были для семьи не лёгкими, но молодые братья были верны своей Идее. С пониманием и желанием создать хорошие аккордеоны, они также уделяли большое внимание Условиям для производства своих инструментов. Фирма PIGINI стала динамично развиваться. Первые поставки были в Америку, затем в Канаду, Швецию, Данию, Аргентину, Египет и Пакистан. Уже в те первые годы была заложена основа к международным контактам, которым фирма PIGINI верна по сей день.',
            },
            ginoPigini: {
                subtitle: 'Джино Пиджини',
                text: 'У руля фирмы стоял многие годы Джино Пиджини, который уже в 14 лет был мастером-наклёпщиком по производству голосов "Vociarolo". Он много сделал для развития идей молодых, жаждущих учёбы, ещё юных мастеров. В кратчайшее время была создана группа из особо талантливых молодых Аккордеонных мастеров. До сегодняшнего дня его отношение к производству является Основой для Качества инструментов PIGINI.',
            },
            philosophy: {
                subtitle: 'Направление фирмы',
                text: 'В Будущем предполагать, а в Прошлом располагать. С таким девизом преодолевает коллектив фирмы PIGINI трудности и препятствия на своём пути. Мы понимаем и любим Аккордеон как инструмент, в котором Искусство и Техника слились воедино с Мастерством и Опытом. Факт, что инструменты PIGINI абсолютно стабильны по качеству и доставляют удовольствие на протяжении многих десятилетий. Это подтверждается тем, что многие известные Солисты, уважаемые Педагоги музыкальных учебных заведений отдают предпочтение инструментам фирмы PIGINI. Это ставит нашу марку на лидирующую позицию в отрасли.',
            },
            craftsmanship: {
                subtitle: 'Ручная работа',
                text: 'Традиции ручной работы нашли Продолжение и Развитие в новейших Технологиях и Процессах изготовления. Столетний опыт в производстве открывает нам всё большие достижения и прогрессивные горизонты.'
            },
            topQualityMaterials: {
                subtitle: 'Качество материала',
                text: 'Каждый инструмент марки PIGINI изготовлен из специального Материала и потому сам по себе является Произведением искусства. Дерево выбирается по абсолютно строгим критериям, Голоса производятся на самой фабрике и собираются вручную в прямой зависимости от Модели инструмента. Благодаря их звуковому качеству они известны во всём Мире. Для создания Меха используется специальная, создающая оптимальные условия для внутреннего воздушного давления, Картонная основа. Лаки, Краски, Фильц, Лайка - все материалы высокого качества, чтобы в результате получился до последней детали ухоженный и высококачественный инструмент.',
            },
            careForDetail: {
                subtitle: 'Детальная обработка',
                text: 'Для звуковой чистоты и эмоциональной насыщенности в исполнении музыкантам часто важны мельчайшие детали. Именно поэтому все механические части наших Аккордеонов PIGINI снабжены различным мягким фильцем, что поддерживает высокий стандарт качества инструментов PIGINI. Они узнаваемы и признаны всеми музыкальными специалистами.',
            },
            selection: {
                subtitle: 'Широкий выбор моделей',
                text: 'По желанию музыканта для выбора в каталоге PIGINI насчитывается более 60 различных моделей. Инструмент, как известно, должен отвечать запросам разных музыкантов, будь он начинающий или известный концертирующий исполнитель. Аккордеоны PIGINI оптимально подходят для всех: как для Учеников, так и для профессиональных Музыкантов. А также они отвечают запросам тех, для кого игра является Хобби.',
            },
            qoi: {
                subtitle: 'Постоянная ценность',
                text: 'Качество ручной работы, применение эксклюзивных материалов превращают каждый инструмент PIGINI в правильную Инвестицию на многие годы. Каждый аккордеон или баян в своём роде Единственный, его Ценность с годами может только возрастать.',
            },
            uniqueness: {
                subtitle: 'Специальные особенности',
                text: 'Простой шуруп, небольшая Вырезка в дереве, Точные пропорции, Подбор фильца и лайки, Обработка с точным ударом, Калибровка механики... Каждый инструмент PIGINI стремится к Совершенству маленьких, не видимых глазу, но сразу ощущаемых Деталей.',
            },
            touch: {
                subtitle: 'Прикосновение',
                text: 'За постоянно хорошими Отзывами об инструментах PIGINI стоит огромное Стремление создать инструмент, отвечающий по своим звуковым качествам всем запросам и возможностям Музыканта.\n' +
                    '\n' +
                    'Результатом является неподражаемое ощущение Удовольствия при игре на каждом инструменте фирмы PIGINI.\n' +
                    '\n' +
                    'Эта Особенность придаёт инструменту особое внутреннее Содержание и Значение.',
            }
        },
        AboutExcelsior: {
            title: 'Об Excelsior',
            beginnings: {
                subtitle: 'Начало',
                text: 'Фабрика была основана в 1924 голу в Нью Йорке. Инструменты, благодаря высокому качеству, стали очень популярны в Америке. Вершины своей популярности они достигли после Второй Мировой войны, когда аккордеон стал необходимым инструментом для каждого оркестра. Такие известные музыканты как Charles Magnante, Art Van Damme, Piero Deiro и др. являются только частью известных музыкантов, выбором которых стал Excelsior.',
            },
            expansion: {
                subtitle: 'Развитие',
                text: 'В 1948 году, с целью повышения уровня производства и продаж в Европе, в Италии, в Кастельфидардо была открыта фабрика. С тех пор замечательный Звук и высокое Качество инструментов Excelsior стал известен во всём Мире.',
            },
            heritage: {
                subtitle: 'Наследство',
                text: 'Традиции Качества и Престижа прошлого продолжаются и сегодня. До сегодняшнего дня, все Аккордеоны Excelsior изготовляются высоко профессиональными мастерами из специально отобранных материалов. Сегодня иметь Excelsior - значит играть на уникальном инструменте и иметь возможность достигнуть уровня популярных музыкантов прошлого и настоящего.',
            },
        },
        Consultations: {
            title: 'Консультации',
            appointments: {
                subtitle: 'Договориться о встрече',
                text: 'Интересно? Желаете попробовать? Тогда свяжитесь с нашим представителем для организации встречи и ничему не обязующей Пробной игре на инструменте. Мы рады Вашему приходу в наш Салон, который находится напротив Московской консерватории. У нас всегда в наличии большой выбор инструментов, которые вы можете попробовать в своё удовольствие. Это гарантирует, что вы сможете принять обоснованное решение и выбрать именно ту модель, который наилучшим образом соответствует вашим потребностям. Будучи опытными музыкантами-аккордеонистами/баянистами и людьми, поддерживающим хорошие отношения со многими мировыми виртуозами аккордеона, Мартин Фрей, Павел Зайцев, Юрий Жмодик - идеально подходят, чтобы предоставить Вам компетентный и правиильный совет, предоставить Вам именно то, что вам нужно.'
            },
            wideSelection: {
                subtitle: "Широкий выбор",
                text: "У нас всегда в наличии большой выбор инструментов, которые вы можете испытать на своё удовольствие. Это гарантирует, что вы сможете принять обоснованное решение и выбрать именно ту аккордеон, который наилучшим образом соответствует вашим потребностям."
            },
            service: {
                subtitle: "Компетентное и честное обслуживание",
                text: "Будучи опытным аккордеонистом и человеком, поддерживающим хорошие отношения с некоторыми из ведущих мировых виртуозов аккордеона, Мартин Фрей идеально подходит, чтобы предоставить вам компетентный и честный совет и предоставить вам именно то, что вам нужно."
            }
        },
        Rentals: {
            title: 'Аренда',
            subtitle: 'Не верный вариант покупки...',
            text: 'Специально для детей, которые ходят в школу и растут, часто нет смысла приобретать аккордеон. Для таких случаев мы предлагаем большой выбор инструментов в аренду. Это гарантирует, что учащиеся всегда имеют в наличии инструмент, который идеально подходит по размеру для их возраста.',
        },
        Repairs: {
            title: 'Ремонты',
            subtitle: 'Когда что-то нужно Изменить',
            text: 'Если на протяжении нескольких лет что-то действительно требует в доводке, мы предоставляем компетентный и быстрый сервис.',
        }
    },
    ContactPage: {
        ContactUsCardTitle: 'связаться с нами',
        ContactUsCardDescription: 'Если предпочитаете, Вы также можете связаться:',
        areasOfInterest: {
            areasOfInterestTitle: 'Сфера интересов',
            sendFurtherInformationChecboxLabel: 'Пожалуйста, пришлите мне дополнительную информацию о ваших инструментах.',
            contactMeForTryOutCheckboxLabel:'Пожалуйста, свяжитесь со мной для встречи, меня заинтересовали инструменты.',
            interestedInRentingCheckboxLabel:'i Меня интересует аренда инструмента. Пожалуйста, свяжитесь со мной для уточнения деталей.',
        },
        contactInformation: {
            titleLabel: 'Разделы',
            titleMrValueLabel: 'Г-н',
            titleMsValueLabel: 'Г-жа',
            firstNameLabel: 'Имя',
            lastNameLabel: 'Фамилия',
            streetLabel: 'Улица',
            houseNumberLabel: 'номер дома',
            zipLabel: 'Индекс',
            cityLabel: 'Город',
            phoneLabel: 'Телефон',
            mobileLabel: 'Мобильный',
            emailLabel: 'Эл. адрес',
            preferredMethodOfContactLabel: 'Предпочтительный способ контакта',
            additionalInformationTitle: 'Дополнительная информация (необязательно)',
            sendButtonLabel: 'Представлять'
        }
    },
    AccordionsPage: {
        titleToBuy: 'Аккордеоны для покупки',
        titleToRent: 'Аккордеоны в аренду',
        Filter: {
            resetFilterBtnLabel: 'Сбросить фильтр',
            brandTitle: 'Бренд',
            generalCategoryTitle: 'Общий',
            rightHandCategoryTitle: 'правая рука',
            leftHandCategoryTitle: 'левая рука',
            standardBassCategoryTitle: 'Стандартный бас',
            characteristicsCategoryTitle: 'характеристики',
            freeBassCategoryTitle: "Свободный бас",
            isRental: 'Аренда',
            Condition: {
                title: 'Состояние',
                used: 'Б/у',
                new: 'Новый',
            },
            BassType: {
                title: 'Бас',
                convertor: 'Готово-выборный',
                standard: 'Готовый',
            },
            RightHandSystem: {
                title: 'Параметры',
                keys: 'клавишный',
                buttons: 'Кнопка'
            },
            Weight: {
                title: 'Вес'
            },
            Height: {
                title: 'Высота'
            },
            Width: {
                title: 'ширина'
            },
            Rows: {
                title: 'ряды'
            },
            RightHandButtons: {
                title: 'Ноты для кнопки',
            },
            ChorusRight: {
                title: 'хор'
            },
            CassottoRight: {
                title: 'кассотто',
            },
            RegisterRight: {
                title: 'регистры'
            },
            ChinSwitches: {
                title: 'подбородочные переключатели'
            },
            StandardBassChorus: {
                title: 'Хор'
            },
            RegisterSb: {
                title: 'регистры'
            },
            FreeBassNotes: {
                title: 'Ноты',
            },
            ChorusFb: {
                title: 'хор',
            },
            RightNotesPiano: {
                title: 'Ноты для фортепиано'
            },
            ReedsFilter: {
                title: 'Язычки',
                tam: 'Tipo a Mano',
                fam: 'Сделано вручную',
                durall: 'Durall',
                turbo: 'Turbo',
                none: 'Нет'
            }
        },
        DeleteAccordion: {
            ConfirmationDialogTitle: 'Удалить аккордеон',
            ConfirmationDialogContent: 'Вы уверены, что хотите удалить аккордеон? После удаления вам придется обратиться к администратору для его восстановления. В процессе могут быть потеряны данные.',
        },
        PublishAccordion: {
            ConfirmationDialogTitle: 'Опубликовать аккордеон',
            ConfirmationDialogContent: 'Вы уверены, что хотите опубликовать аккордеон? После публикации все смогут увидеть этот аккордеон в магазине. Только администратор может «снять с публикации».',
        },
        UnpublishAccordion: {
            ConfirmationDialogTitle: 'Отменить публикацию аккордеона',
            ConfirmationDialogContent: 'Вы уверены, что хотите отменить публикацию этого аккордеона? После этого действия публика об этом аккордеоне больше не узнает, пока он снова не будет опубликован.'
        },
        ImageManager: {
            setAsThumbnailButtonLabel: 'Установить как миниатюру'
        },
        accordionNotFoundText: 'Аккордеон не найден',
        accordionAdditionalInformationContactText: 'Меня интересует аккордеон',
    },
    AccessoriesPage: {
        title: 'аксессуары',
        subtitle: 'Откройте для себя идеальные дополнения, чтобы улучшить ваш опыт игры на аккордеоне, с нашим широким ассортиментом аксессуаров. Если вам что-то понравится, не стесняйтесь обращаться к нам напрямую. Кроме того, если вы ищете какой-то конкретный аксессуар, которого нет в нашем каталоге, пожалуйста, свяжитесь с нами. Мы стремимся удовлетворить ваши потребности и гарантировать, что вы найдете именно то, что ищете.',
        Backpacks: {
            title: 'Рюкзаки',
            text: 'Поднимите ваше музыкальное путешествие на новый уровень с нашими высококачественными рюкзаками, специально разработанными для аккордеонов и CH-Örgeli. Эти рюкзаки не только удобны в переноске, но и обеспечивают надежную защиту и стильный дизайн, который дополнит ваш инструмент. Будь вы профессиональный музыкант или увлеченный энтузиаст, наши рюкзаки гарантируют, что ваш аккордеон или CH-Örgeli будет путешествовать комфортно и со стилем. Изучите наш ассортимент специально разработанных рюкзаков, которые символизируют прочность и элегантность.',
            tableData: {
                columnNameDef: ['', '', 'Цена'],
                columnKeyDef: ['text', 'currency', 'price'],
                rows: [
                    { text: 'Рюкзак-аккордеон кордура'              , price: 'От 63' , currency: 'CHF / Euro' },
                    { text: 'рюкзак Schwyzerörgeli'                 , price: 'От 90' , currency: 'CHF / Euro' },
                    { text: 'Мягкая сумка для переноски концертины' , price: 'От 70' , currency: 'CHF / Euro' },
                ]
            }
        },
        ShoulderStraps: {
            title: 'Лямки',
            text: 'Откройте для себя наш широкий ассортимент лямок для аккордеонов, доступных как с крестовиной, так и без неё. Разработанные с учетом уникальных потребностей каждого музыканта, наши лямки представлены в различных размерах, обеспечивая идеальную посадку и непревзойденный комфорт. Будь то улучшенная стабильность за счет крестовины или простота традиционного дизайна, наши лямки предоставляют поддержку, необходимую для удобной и стильной игры на вашем инструменте.',
            tableData: {
                columnNameDef: ['', '', '', 'Цена'],
                columnKeyDef: ['text', 'paddingWidth' ,'currency', 'price'],
                rows: [
                    { text: 'Плечевой ремень-гармошка без перекрещивающихся лямок'  , price: 'От  50', currency: 'CHF / Euro'  , paddingWidth: '45 мм' },
                    { text: 'Плечевой ремень-гармошка с перекрестной лямкой'        , price: 'От  79', currency: 'CHF / Euro'  , paddingWidth: '50 мм' },
                    { text: 'Плечевой ремень-гармошка с перекрестной лямкой'        , price: 'От 100', currency: 'CHF / Euro'  , paddingWidth: '70 мм' },
                    { text: 'Плечевой ремень-гармошка с перекрестной лямкой'        , price: 'От 100', currency: 'CHF / Euro'  , paddingWidth: '80 мм' },
                ]
            }
        },
        AccordionDustCovers: {
            title: 'Чехлы от пыли',
            text: 'Защитите свой аккордеон от пыли и мелких царапин с помощью нашего ассортимента чехлов от пыли, доступных в маленьких, средних размерах и размерах для конверторов. Эти чехлы изготовлены таким образом, чтобы обеспечить плотное прилегание, гарантируя всестороннюю защиту вашего инструмента. Идеально подходящие для хранения и ежедневной защиты, наши чехлы помогают поддерживать ваш музыкальный инструмент в идеальном состоянии, когда он не используется. Изучите наш ассортимент, чтобы найти идеальный чехол, соответствующий вашим потребностям.',
            tableData: {
                columnNameDef: ['', '', 'Цена'],
                columnKeyDef: ['text', 'currency', 'price'],
                rows: [
                    { text: 'Защитный чехол-аккордеон маленький'    , price: '20', currency: 'CHF / Euro' },
                    { text: 'Защитный чехол аккордеон средний'      , price: '20', currency: 'CHF / Euro' },
                    { text: 'Защитный чехол-аккордеон большой'      , price: '20', currency: 'CHF / Euro' },
                ]
            }
        },
        AccordionGloveLeftHand: {
            title: 'Перчатка для Левой Руки для Аккордеонов',
            text: 'Повысьте комфорт и контроль с нашей специально разработанной перчаткой для левой руки для аккордеонистов. Изначально изобретенная для защиты руки музыканта от постоянного трения и давления при управлении басовыми кнопками, эти перчатки также помогают поддерживать постоянную температуру, предотвращая влияние пота на выступление. Наша перчатка для левой руки изготовлена из высококачественных материалов, обеспечивающих долговечность и гибкость, позволяющие вам играть длительное время без дискомфорта. Изучите наш ассортимент, чтобы найти идеальную перчатку, которая улучшит вашу точность и выносливость в игре.',
            tableData: {
                columnNameDef: ['', '', 'Цена'],
                columnKeyDef: ['text', 'currency', 'price'],
                rows: [
                    { text: 'Защитная перчатка для аккордеона на левую руку', price: '35', currency: 'CHF / Euro' }
                ]
            }
        }
    },
    ConfirmationDialog: {
      DefaultDialogTitle: 'Пожалуйста, подтвердите',
      DefaultDialogContent: 'Пожалуйста, подтвердите ваше предложенное действие'
    },
    GeneralComponentLabels: {
        notes: 'Ноты',
        range: 'Диапазон',
        from: 'от',
        to: 'до',
        deleteButtonLabel: 'удалить',
        cancelButtonLabel: 'отменить',
        createButtonLabel: 'Создать',
        publishButtonLabel: 'Опубликовать',
        unpublishButtonLabel: 'Отменить публикацию',
        manageImagesButtonLabel: 'Управление изображениями',
        closeButtonLabel: 'Закрыть',
        backButtonLabel: 'Назад',
        speed: 'Скорость',
        price: 'Цена',
        product: 'Продукт',
        currency: 'Валюта',
        paddingWidth: 'Ширина набивки'
    },
    ShopShortcut: {
        buy: 'покупать',
        rent: 'арендовать',
    }
}

export default russianMessages;